function Dashboard() {
  return (
    <div>
      <h1>Dashboard</h1>
      <p>Welcome to Club OS Dashboard</p>
    </div>
  );
}

export default Dashboard;
